module.exports = __webpack_public_path__ + "static/media/modify.fb06266d.svg";